import cloneDeep from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';
import {
  DO_BACKUP,
  jump,
  randomAccessJump,
  updateBackupData,
  updateData,
  updateSupportData,
} from '../../../AdvWorkflow/AdvWorkflowActions';
import { ITERATOR_POST_END } from '../../../AdvWorkflow/AdvWorkflowHelpers';

const clearStagedGoal = (operation, workflowId, clientId, dispatch) => {
  // update to null and {} because the
  // framework will merge if we update directly to {}.
  const dataSequence = [null, {}];
  dataSequence.forEach(element => {
    dispatch(
      operation(
        {
          HomePurchaseGoal: element,
        },
        workflowId,
        clientId,
      ),
    );
  });
};

export const onAddGoal = (workflowId, clientId) => dispatch => {
  clearStagedGoal(updateData, workflowId, clientId, dispatch);
  clearStagedGoal(updateSupportData, workflowId, clientId, dispatch);

  const newGoalId = uuidv4();

  dispatch(
    updateData(
      {
        HomePurchaseGoal: {
          Id: newGoalId,
        },
      },
      workflowId,
    ),
  );

  dispatch(
    updateBackupData(workflowId, {
      HomePurchaseGoal: {
        Id: newGoalId,
      },
    }),
  );

  dispatch(
    updateSupportData(
      {
        BlockAutoOutput: false,
      },
      workflowId,
    ),
  );

  dispatch(jump(1, workflowId));
};

export const onEditGoal = (homePurchaseGoal, workflowId, clientId) => dispatch => {
  dispatch(
    updateData(
      {
        HomePurchaseGoal: {
          ...cloneDeep(homePurchaseGoal),
        },
      },
      workflowId,
    ),
  );

  dispatch(
    updateSupportData(
      {
        BlockAutoOutput: true,
        HomePurchaseGoal: {
          HasPlanToGetMortgage: homePurchaseGoal.MortgageType !== null,
          HasHomeownerAssociationFee: !!homePurchaseGoal.MonthlyHoa,
        },
      },
      workflowId,
    ),
  );

  dispatch(randomAccessJump(workflowId, clientId, ITERATOR_POST_END));
};

export const onDeleteGoal = (goalId, workflowId, clientId, homePurchaseGoals) => dispatch => {
  dispatch(
    updateData(
      {
        HomePurchaseGoals: homePurchaseGoals.filter(({ Id }) => Id !== goalId),
      },
      workflowId,
    ),
  );

  dispatch({
    type: DO_BACKUP,
    workflowId,
    clientId,
  });
};
